import { Component, Input, Pipe } from '@angular/core'

@Component({
  selector: 'app-info-label-description',
  templateUrl: './info-label-description.component.html',
})
export class InfoLabelDescriptionComponent {
  @Input() label: string = ''
  @Input() description: string = ''
  @Input() isHidden: boolean = false;
  @Input() isCurrency: boolean = false;

  getDisplayText(): string {
    return this.isHidden ? '************' : this.description;
  }
}
